module.exports = __webpack_public_path__ + "static/sentenceDiagram-a0e74891a265721fe2699aafabad62cb.svg";